import { Injectable } from '@angular/core';

export enum StoreKeysEnum {
	AUTH = 'AUTH',
	REQUEST_PATH = 'REQUEST_PATH',
	DARK_MODE = 'DARK_MODE',
	SHOW_CALENDAR_TIME = 'SHOW_CALENDAR_TIME',
}

@Injectable({
	providedIn: 'root',
})
export class StoreService {
	set(key: StoreKeysEnum, value: string) {
		localStorage.setItem(key, value);
	}

	get(key: StoreKeysEnum): string | null {
		return localStorage.getItem(key);
	}
}
